Ext.define('SA.view.CheckField', {
    alias: 'widget.sa-check-field',
    extend: 'Ext.Component',

    encodeBoxLabel: true,
    maskOnDisable: false,

    activeCls: {
        '.sa-check-field-label': 'sa-check-field-label-active'
    },

    clickHandlers: {
        '.sa-check-field-label': 'onLabelClick'
    },

    hoverCls: {
        '.sa-check-field-label': 'sa-check-field-label-hover'
    },

    renderTpl: [
        '<label class="sa-check-field-label {baseCls}-label">',
            '<span aria-checked="{checked}" aria-label="{ariaLabel}" class="sa-check-field-button {baseCls}-button" role="{role}" tabindex="0"></span>',
            '<tpl if="boxLabel">',
                '<span class="sa-check-field-label-text {baseCls}-label-text">{boxLabel}</span>',
            '</tpl>',
        '</label>'
    ],

    initComponent() {
        this.callParent();

        this.addCls('sa-check-field');

        this.setCheckedImpl(this.checked);
    },

    addClsBySelector(ev, clsMap) {
        for (let selector in clsMap) {
            let el = ev.getTarget(selector);

            if (el) {
                Ext.fly(el).addCls(clsMap[selector]);
            }
        }
    },

    beforeRender() {
        this.protoEl.unselectable();

        this.callParent();

        Ext.applyIf(this.renderData, this.getTemplateArgs());
    },

    getTemplateArgs() {
        var rawLabel = this.boxLabel ?? '',
            ariaLabel = rawLabel.replace(Ext.data.SortTypes.stripTagsRE, '');

        return {
            ariaLabel,
            boxLabel: this.encodeBoxLabel ? Ext.String.htmlEncode(rawLabel) : rawLabel,
            checked: this.checked,
            role: this.ariaRole ?? 'checkbox'
        };
    },

    initEvents() {
        var el = this.el;

        this.callParent();

        if (this.clickHandlers) {
            el.on('click', this.onClick, this);
            el.on('keydown', this.onKeyDown, this);
        }

        if (this.hoverCls) {
            el.on({
                mouseout: this.onMouseOut,
                mouseover: this.onMouseOver,

                scope: this
            });
        }

        if (this.activeCls) {
            el.on({
                mousedown: this.onMouseDown,
                mouseup: this.onMouseUp,

                scope: this
            });
        }
    },

    isChecked() {
        return this.checked;
    },

    onClick(ev) {
        var clickHandlers = this.clickHandlers;

        if (this.disabled) {
            return;
        }

        for (let selector in clickHandlers) {
            if (ev.getTarget(selector)) {
                Ext.callback(clickHandlers[selector], this, ev);
            }
        }
    },

    onKeyDown(ev) {
        var keyCode = ev.getKey();

        if (keyCode === ev.ENTER || keyCode === ev.SPACE) {
            this.onClick(ev);
        }
    },

    onMouseDown(ev) {
        if (!this.disabled) {
            this.addClsBySelector(ev, this.activeCls);
        }
    },

    onMouseOut(ev) {
        this.removeClsBySelector(ev, this.hoverCls);
    },

    onMouseOver(ev) {
        if (!this.disabled) {
            this.addClsBySelector(ev, this.hoverCls);
        }
    },

    onMouseUp(ev) {
        this.removeClsBySelector(ev, this.activeCls);
    },

    removeClsBySelector(ev, clsMap) {
        for (let selector in clsMap) {
            let el = ev.getTarget(selector);

            if (el) {
                Ext.fly(el).removeCls(clsMap[selector]);
            }
        }
    },

    setChecked(checked, {suppressEvent = false} = {}) {
        const oldChecked = this.isChecked();

        this.setCheckedImpl(checked);

        if (this.rendered) {
            const button = this.el.down('.sa-check-field-button');

            button.el.dom.setAttribute('aria-checked', checked);
        }

        if (checked !== oldChecked && !suppressEvent) {
            Ext.callback(this.handler, this.scope || this, [this, checked]);

            this.fireEvent('change', this, checked);
        }
    },

    setCheckedImpl(checked) {
        this.checked = !!checked;

        this.ifCls(checked, this.baseCls + '-checked');
    },

    setCheckedSuppressed(checked) {
        this.setChecked(checked, {suppressEvent: true});
    },

    setLabelHtml(labelHtml) {
        this.el.dom.querySelector('.sa-check-field-label-text').innerHTML = labelHtml;
    }
});
